module.exports = __webpack_public_path__ + "img/play_btn.0584f332.png";